/* eslint-disable max-lines */
import FIELD_TYPE from 'Component/Field/Field.config';
import {
    getVatFields as sourceGetVatFields
} from 'SourceComponent/MyAccountAddressForm/MyAccountAddressForm.form';
import {
    VALIDATION_BANNED_CHAR_STREET_REGEXP,
    VALIDATION_INPUT_TYPE
} from 'Util/Validator/Config';

// TODO: implement getVatFields
export const getVatFields = sourceGetVatFields;

/**
 * Returns fields for street
 * @param props
 * @returns {[{addRequiredTag: boolean, validateOn: string[], validationRule: {isRequired: boolean}, label: *, type: string, attr: {defaultValue: (*|string), name: string, placeholder: *}}]|*[]}
 * @namespace Bodypwa/Component/MyAccountAddressForm/Form/getStreetFields */
export const getStreetFields = (props) => {
    const {
        addressLinesQty = 1,
        address,
        address: { street = [] }
    } = props;

    if (addressLinesQty === 1) {
        return [{
            type: FIELD_TYPE.text,
            label: __('Street address'),
            attr: {
                name: 'street',
                defaultValue: street[0] || '',
                placeholder: __('Your street address')
            },
            addRequiredTag: true,
            validateOn: ['onChange'],
            validationRule: {
                isRequired: true,
                match: VALIDATION_BANNED_CHAR_STREET_REGEXP
            }
        }];
    }

    const streets = [];

    // eslint-disable-next-line fp/no-loops, fp/no-let
    for (let i = 0; i < addressLinesQty; i++) {
        streets.push({
            type: FIELD_TYPE.text,
            label: i ? __('Apartment, Suite, Building (Optional)') : __('Street address'),
            attr: {
                name: `street_${i}`,
                defaultValue: address[`street_${i}`] || street[i] || '',
                placeholder: i ? __('Apartment, Suite, Building (Optional)') : __('Street address')
            },
            addRequiredTag: i === 0,
            validateOn: i === 0 ? ['onChange'] : [],
            validationRule: {
                isRequired: i === 0,
                match: VALIDATION_BANNED_CHAR_STREET_REGEXP
            }
        });
    }

    return streets;
};

/**
 * Returns region fields
 * @param props
 * @param events
 * @returns {[{addRequiredTag: boolean, validateOn: (string[]|*[]), validationRule: {isRequired}, options, label: *, type: string, attr: {defaultValue: number, name: string, selectPlaceholder: *}}]|*[]|[{validateOn: (string[]|*[]), validationRule: {isRequired}, label: *, type: string, attr: {defaultValue, name: string, id: string, placeholder: *}}]}
 * @namespace Bodypwa/Component/MyAccountAddressForm/Form/getRegionFields */
export const getRegionFields = (props, events) => {
    const {
        region: { region, region_id: regionId = 1 } = {},
        regionDisplayAll,
        availableRegions,
        isStateRequired,
        currentRegion,
        currentRegionId
    } = props;

    const { onRegionChange, onRegionIdChange } = events;

    if (!regionDisplayAll && !isStateRequired) {
        return [];
    }

    if (!availableRegions || !availableRegions.length) {
        return [
            {
                type: FIELD_TYPE.text,
                label: __('State / Province'),
                attr: {
                    id: 'address-region-id',
                    name: 'region_string',
                    value: currentRegion,
                    defaultValue: region,
                    placeholder: __('Your state / province')
                },
                events: {
                    onChange: onRegionChange
                },
                addRequiredTag: isStateRequired,
                validateOn: isStateRequired ? ['onChange'] : [],
                validationRule: {
                    isRequired: isStateRequired
                }
            }
        ];
    }

    return [
        {
            type: FIELD_TYPE.select,
            label: __('State / Province'),
            attr: {
                name: 'region_id',
                value: currentRegionId,
                defaultValue: regionId,
                selectPlaceholder: __('Select region...')
            },
            events: {
                onChange: onRegionIdChange
            },
            options: availableRegions.map(({ id, name }) => ({ id, label: name, value: id })),
            addRequiredTag: isStateRequired,
            validateOn: isStateRequired ? ['onChange'] : [],
            validationRule: {
                isRequired: isStateRequired
            }
        }
    ];
};

/** @namespace Bodypwa/Component/MyAccountAddressForm/Form/myAccountAddressForm */
export const myAccountAddressForm = (props, events = {}) => {
    const {
        default_billing: defaultBilling,
        default_shipping: defaultShipping,
        countryId,
        firstname = '',
        lastname = '',
        city = '',
        countries = [],
        postcode: zipcode = '',
        telephone = '',
        addressLinesQty = 1,
        currentCity,
        currentZipcode
    } = props;

    const {
        onCountryChange,
        onZipcodeChange,
        onCityChange
    } = events || {};

    return [

        {
            type: FIELD_TYPE.checkbox,
            label: __('This is default Billing Address'),
            attr: {
                name: 'default_billing',
                defaultChecked: defaultBilling
            }
        },
        {
            type: FIELD_TYPE.checkbox,
            label: __('This is default Shipping Address'),
            attr: {
                name: 'default_shipping',
                defaultChecked: defaultShipping
            }
        },
        {
            name: 'customerDataGroup',
            fields: [
                {
                    type: FIELD_TYPE.text,
                    label: __('First name'),
                    attr: {
                        name: 'firstname',
                        defaultValue: firstname,
                        placeholder: __('Your first name')
                    },
                    addRequiredTag: true,
                    validateOn: ['onChange'],
                    validationRule: {
                        isRequired: true
                    }
                },
                {
                    type: FIELD_TYPE.text,
                    label: __('Last name'),
                    attr: {
                        name: 'lastname',
                        defaultValue: lastname,
                        placeholder: __('Your last name')
                    },
                    addRequiredTag: true,
                    validateOn: ['onChange'],
                    validationRule: {
                        isRequired: true
                    }
                }
            ]
        },
        {
            name: 'streetGroup',
            mods: {
                street: true,
                multipleFields: addressLinesQty > 0,
                oddAddresses: addressLinesQty % 2 === 1
            },
            fields: getStreetFields(props)
        },
        {
            name: 'addressGroup',
            mods: { address: true },
            fields: [
                {
                    type: FIELD_TYPE.text,
                    label: __('Zip / Postal code'),
                    attr: {
                        name: 'postcode',
                        value: currentZipcode,
                        defaultValue: zipcode,
                        placeholder: __('Your zip / postal code')
                    },
                    events: {
                        onChange: onZipcodeChange
                    },
                    addRequiredTag: true,
                    validateOn: ['onChange', 'onBlur'],
                    validationRule: {
                        isRequired: true
                    }
                },
                {
                    type: FIELD_TYPE.text,
                    label: __('City'),
                    attr: {
                        name: 'city',
                        value: currentCity,
                        defaultValue: city,
                        placeholder: __('Your city')
                    },
                    events: {
                        onChange: onCityChange
                    },
                    addRequiredTag: true,
                    validateOn: ['onChange'],
                    validationRule: {
                        isRequired: true
                    }
                },
                {
                    type: FIELD_TYPE.select,
                    label: __('Country'),
                    attr: {
                        id: 'address-country-id',
                        name: 'country_id',
                        defaultValue: countryId,
                        selectPlaceholder: __('Select country...')
                    },
                    events: {
                        onChange: onCountryChange
                    },
                    options: countries,
                    addRequiredTag: true,
                    validateOn: ['onChange'],
                    validationRule: {
                        isRequired: true
                    }
                },
                {
                    type: FIELD_TYPE.text,
                    label: __('Phone number'),
                    attr: {
                        name: 'telephone',
                        defaultValue: telephone,
                        placeholder: __('Your phone number')
                    },
                    addRequiredTag: true,
                    validateOn: ['onChange'],
                    validationRule: {
                        inputType: VALIDATION_INPUT_TYPE.phone,
                        isRequired: true
                    }
                }
            ]
        },
        ...getVatFields(props),
        {
            name: 'phoneGroup', // TODO cahnge group name
            fields: []
        }
    ];
};

export default myAccountAddressForm;
